<template>
	<el-dialog :visible.sync="visible"
		:title="$t('retailInstance.text.batchRename')"
		:close-on-click-modal="false"
		:before-close="handleClose" class="bind-dialog  create-host">
        <div class="tip-warning mb20" style="line-height: 19px"
             v-html="$t('privateNetInstance.batchRenameTips')">
        </div>
        <batch-instance-table v-bind="$attrs" :multipleSelection="multipleSelection">
        </batch-instance-table>
        <div style="margin-top: 30px;">
            <el-form 
                label-width="110px" :model="ruleForm"
                ref="ruleForm" :rules="rules"
				@submit.native.prevent>
                <el-form-item 
                    :label="$t('detail.text.newName') | withColon" 
                    prop="hostName"
                    :show-message="false" required
                    ref="hostName">
                    <el-input 
                        v-model="ruleForm.hostName" 
						@keyup.enter.native="sureBind"
                        @blur="ruleFormTag.hostName=1"
                        @focus="ruleFormTag.hostName=0"
						></el-input>
                    <p v-if="ruleFormTag.hostName!==0 && ruleForm.hostName==''"
                        class="el-form-item-help-error">
                        {{$t('create.placeholder.nameNull')}}</p>
                    <p v-else class="el-form-item-help"
                        :class="{'el-form-item-help-error': this.ruleFormTag.hostName == 'error'}">
                        {{$t('create.help.instanceNameRule')}}</p>
                </el-form-item>
            </el-form>
        </div>
		<div slot="footer">
			<el-button @click="cancelBind">
				{{ $t('privateNetInstance.cancel') }}
			</el-button>
			<el-button @click="sureBind"
				type="primary">
				{{ $t('privateNetInstance.bindSure') }}
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
import BatchInstanceTable from '@/components/common/BatchInstanceTable';
export default {
	name: 'BatchRename',
    components: {
        BatchInstanceTable
    },
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		multipleSelection: {
			type: Array,
			default: []
		},
		region: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
            // 表单验证
			ruleForm: {
				hostName: '',
			},
			ruleFormTag: {
				hostName: 0,
			},
            rules: {
				hostName: [
					{
						type: 'string',
						pattern: new RegExp('^[a-zA-Z\\\u4e00-\\\u9fa5]([0-9a-zA-Z\\\u4e00-\\\u9fa5-_.:]{1,127})$'),
						trigger: 'blur'
					}
				],
			},
		};
	},
	methods: {

		handleClose() {
            this.resetInitParams();
            this.ruleFormTag.hostName = 0;
			this.$emit('update:visible', false);
		},
		cancelBind() {
			this.handleClose();
		},
        resetInitParams() {
            this.$refs.ruleForm.resetFields();
        },
        sureBind() {
            this.$refs.ruleForm.validate((valid) => {
                if (!valid) {
                    return false
                } else {
                    this.rename();
                }
            })
        },
		rename() {
			let instanceIds = this.multipleSelection.map(item => item.instanceId)
			const params = {
				region: this.region,
				name:this.ruleForm.hostName,
				clientToken: Normal.getClientToken(),
				instanceIds
			};

			Ajax.put('/api/cps/modifyInstances', params,{
				headers: {
					'Content-Type': 'application/json'
				}
			})
			.then((res) => {
				this.$message.success(this.$t('privateNetInstance.operateSuccess'));
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			})
			.finally(() => {
				this.handleClose();
				this.$emit('refresh');
			});
		},
	}
};
</script>

<style lang="scss">
	.bind-dialog {
		.chooseInfo {
			margin-bottom: 5px;
			font-size: 12px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/BatchRename.vue